var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_569_808)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7002 21.7385C27.3238 21.2916 26.7828 21.2446 26.3359 21.5503C25.6302 22.0208 24.8775 22.5148 24.3129 23.1264C23.3014 24.2084 22.0312 24.1379 20.7374 24.0908C20.4081 24.0908 20.0788 23.9967 20.0553 23.5968C20.0553 23.1264 20.4316 23.0793 20.7845 23.0793C21.2079 23.0793 21.6548 23.0558 22.0782 23.0793C22.878 23.1029 23.419 22.75 23.419 21.9502C23.3955 21.221 22.878 20.9152 22.1253 20.9388C20.808 20.9858 19.4672 21.0093 18.1499 20.9388C16.7621 20.8447 15.9858 21.8561 15.0214 22.5383C14.7626 22.703 14.8332 22.9382 14.9978 23.1264C15.9623 24.2555 16.715 25.5963 17.8676 26.6078C19.5142 26.6078 21.1373 26.6313 22.7839 26.6313C24.7598 25.8786 26.1477 24.326 27.7237 23.0323C28.1236 22.6794 28.0295 22.1384 27.7002 21.7385Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5363 16.0224C22.6419 16.0459 23.5358 15.1521 23.5358 14.023C23.5358 12.8468 22.736 12.0235 21.5834 12C20.4543 12 19.5604 12.8468 19.5369 13.9524C19.5369 15.058 20.4543 16.0224 21.5363 16.0224Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1498 23.785C13.7969 23.3381 13.5382 23.7615 13.2559 23.9261C12.8795 24.1378 12.9736 24.3966 13.1853 24.6789C14.0086 25.6668 14.8084 26.6783 15.5847 27.6898C15.7728 27.925 15.914 28.1603 16.2198 27.8545C16.4315 27.6428 16.7843 27.5487 16.7843 27.1723C16.7373 27.1017 16.7138 27.0312 16.6667 26.9606C15.8434 25.9256 14.9966 24.8435 14.1498 23.785Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6646 19.7627C25.2762 18.516 24.7116 17.3164 23.4179 17.2458C22.2182 17.1988 20.995 17.1988 19.7953 17.2693C18.4075 17.3399 17.8665 18.516 18.5721 19.8098C20.5951 19.8804 22.6181 19.9509 24.6646 19.7627Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_808",
    x1: -5.82139e-7,
    y1: 40,
    x2: 47.1439,
    y2: 24.4353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C681CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79DE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfManagementIcon);
export default __webpack_public_path__ + "static/media/SelfManagementIcon.2c1e54549db04de79cadc08a86af4d47.svg";
export { ForwardRef as ReactComponent };